import { AuthService } from '../services/auth/auth-service';
import { UiElements, UiStateModelBase } from './ui-state-model';

export class UiStateModelImpl extends UiStateModelBase {
    constructor() {
        super();

        for (let [key, value] of new URLSearchParams(location.search).entries()) {
            this._stateMap.set(key, value);
        }

        AuthService.addEventListener("logged-in", () => this._updateAddressBar() );
    }

    getValue(key: string) {
        return this._stateMap.get(key);
    }

    setValue(key: string, value?: string|null) {
        // Detect no-ops
        if (!value && !this._stateMap.has(key))
        {
            return;
        }
        else if (value && this._stateMap.get(key) === value)
        {
            return;
        }

        const oldValue = this.getValue(key);
        if (!value) {
            this._stateMap.delete(key);
        } else {
            this._stateMap.set(key, value);
        }
        this.dispatchEvent(new CustomEvent(`${key}-change`, {detail: {value, old: oldValue}}));
        this._updateAddressBar();
    }

    toggleElementVisibility(key: UiElements) {
        this.dispatchEvent(new CustomEvent(`${key}-toggled`));
    }

    private _stateMap: Map<string, string> = new Map(); // UI state URL

    private _updateAddressBar() {
 
        // If not logged in yet, we cannot touch the address bar without MSAL potentially going into a page reload loop (sigh...)
        if (!AuthService.isLoggedIn)
        {
            return;
        }

        const params = new URLSearchParams();
        for (let [key, value] of this._stateMap) {
            params.set(key, value);
        }

        // Prevent escaping of query commas
        const paramStr = params.toString().
            replace(/\%2C/gi, ',').
            replace(/\%3A/gi, ':').
            replace(/\%21/gi, '!');

        window.history.replaceState({}, '', `${location.pathname}?${paramStr}`);
    }
}
